import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "./Upload.css";
import { BASE_URL } from "./Constants";
import useAuth from './useAuth';
import * as XLSX from "xlsx";

const Reports = () => {
  const [question, setQuestion] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  useAuth();

  useEffect(() => {
    const fetchsetQuestion = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await fetch(`${BASE_URL}reports`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch questions");
        const data = await response.json();
        setQuestion(data.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchsetQuestion();
  }, []);

  useEffect(() => {
  let filtered = question;

  
  // 🔹 Year filter (based on created_on)
if (selectedYear) {
  filtered = filtered.filter(item => {
    if (!item.created_on) return false;

    const itemYear = new Date(item.created_on).getFullYear();
    return itemYear.toString() === selectedYear;
  });
}


  // 🔹 Search filter
  if (searchQuery) {
    const q = searchQuery.toLowerCase();

    filtered = filtered.filter(item =>
      (item.emp_id && item.emp_id.toLowerCase().includes(q)) ||
      (item.comp_name && item.comp_name.toLowerCase().includes(q)) ||
      (item.question && item.question.toLowerCase().includes(q)) ||
      (item.dept_name && item.dept_name.toLowerCase().includes(q)) ||
      (item.location_name && item.location_name.toLowerCase().includes(q)) ||
      (item.secured_marks && item.secured_marks.toString().includes(q))
    );
  }

  setFilteredQuestions(filtered);

}, [searchQuery, selectedYear, question]);



  const paginateQuestions = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredQuestions.slice(startIndex, endIndex);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleRowsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const formattedData = filteredQuestions.map((item, index) => ({
      "S.No": index + 1,
      "Employee ID": item.emp_id,
      "Employee Name": item.comp_name,
      "Department": item.dept_name,
      "Location": item.location_name,
      "Question": item.question,
      "Secured Marks": item.secured_marks,
      "Created By": item.created_by,
      "Created On": item.created_on,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employee Reports");
    XLSX.writeFile(wb, "employee_reports.xlsx");
  };


  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Employee List</h4>

                    <div className="mb-3">
                      <div className="row">
                        <div className="col-lg-1">
                          <select
                            className="form-control input-font"
                            value={itemsPerPage}
                            style={{ padding: "0px 10px" }}
                            onChange={handleRowsPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control input-font"
                            placeholder="Search by Employee ID, Question, etc."
                            value={searchQuery}
                            onChange={handleSearchChange}
                          />
                        </div>
                        <div className="col-lg-1"><button
                          className="btn btn-success mb-3 input-font"
                          style={{ padding: "5px 10px" }}
                          onClick={exportToExcel}
                        >
                          Export to Excel
                        </button></div>
                        <div className="col-lg-2">
  <select
    className="form-control input-font"
    value={selectedYear}
    onChange={(e) => {
      setSelectedYear(e.target.value);
      setCurrentPage(1);
    }}
  >
    <option value="">All Years</option>
    <option value="2026">2026</option>
    <option value="2025">2025</option>
  </select>
</div>

                      </div>
                    </div>

                    {loading && <p>Loading...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}

                    {!loading && !error && filteredQuestions.length > 0 && (
                      <>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Employee ID</th>
                              <th>Employee Name</th>
                              <th>Department</th>
                              <th>Location</th>
                              <th>Question</th>
                              <th>Secured Marks</th>
                              <th>Created On</th>
                            </tr>
                          </thead>

                          <tbody>
                            {paginateQuestions().map((item, index) => (
                              <tr key={index}>
                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                <td>{item.emp_id}</td>
                                <td>{item.comp_name}</td>
                                <td>{item.dept_name}</td>
                                <td>{item.location_name}</td>
                                <td>{item.question}</td>
                                <td>{item.secured_marks}</td>
                                <td>{item.created_on}</td>
                              </tr>
                            ))}
                          </tbody>

                        </table>
                        <br />
                        <div className="pagination">
                          <button
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="btn btn-secondary"
                          >
                            Previous
                          </button>
                          <span className="mx-3">Page {currentPage}</span>
                          <button
                            onClick={() =>
                              setCurrentPage((prev) =>
                                Math.min(prev + 1, Math.ceil(filteredQuestions.length / itemsPerPage))
                              )
                            }
                            disabled={currentPage === Math.ceil(filteredQuestions.length / itemsPerPage)}
                            className="btn btn-secondary"
                          >
                            Next
                          </button>
                        </div>

                        <div className="row-count-display">
                          <p>
                            Showing {(currentPage - 1) * itemsPerPage + 1}-
                            {Math.min(currentPage * itemsPerPage, filteredQuestions.length)} of{" "}
                            {filteredQuestions.length} rows
                          </p>
                        </div>
                      </>
                    )}

                    {!loading && !error && filteredQuestions.length === 0 && (
                      <p>No questions found</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="footer">
            <span className="text-muted">© {new Date().getFullYear()} Vijaya Diagnostic Centre</span>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Reports;